import { render, staticRenderFns } from "./projects.vue?vue&type=template&id=5bd4b61a&scoped=true&"
import script from "./projects.vue?vue&type=script&lang=js&"
export * from "./projects.vue?vue&type=script&lang=js&"
import style0 from "./projects.vue?vue&type=style&index=0&id=5bd4b61a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd4b61a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/kivateknoloji/kivacloud/corona-ux/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bd4b61a')) {
      api.createRecord('5bd4b61a', component.options)
    } else {
      api.reload('5bd4b61a', component.options)
    }
    module.hot.accept("./projects.vue?vue&type=template&id=5bd4b61a&scoped=true&", function () {
      api.rerender('5bd4b61a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/crm/components/account/projects.vue"
export default component.exports